import { render, staticRenderFns } from "./terminals.vue?vue&type=template&id=2e4906e0&scoped=true&"
import script from "./terminals.vue?vue&type=script&lang=ts&"
export * from "./terminals.vue?vue&type=script&lang=ts&"
import style1 from "./terminals.vue?vue&type=style&index=1&id=2e4906e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4906e0",
  null
  
)

export default component.exports